import { Search, X } from 'lucide-react';
import { useProductFilters } from '../store/filters.store';

export function ProductFilters() {
  const f = useProductFilters();
  const hasFilters = !!(f.search || f.isActive !== undefined);

  return (
    <div className="glass-panel rounded-xl p-4 flex flex-wrap items-center gap-3">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-on-surface-variant" />
        <input
          value={f.search ?? ''}
          onChange={(e) => f.setFilter('search', e.target.value || undefined)}
          placeholder="Search name or code"
          className="w-full pl-9 pr-3 py-2 rounded-lg bg-surface-container-lowest border border-border-subtle text-sm focus:outline-none focus:ring-2 focus:ring-electric-violet/30"
        />
      </div>
      <label className="flex items-center gap-2 text-xs">
        <span className="text-on-surface-variant uppercase tracking-widest font-bold">Status</span>
        <select
          value={f.isActive === undefined ? '' : f.isActive ? 'true' : 'false'}
          onChange={(e) => f.setFilter('isActive', e.target.value === '' ? undefined : e.target.value === 'true')}
          className="px-2 py-1.5 rounded-md bg-surface-container-lowest border border-border-subtle text-sm focus:outline-none focus:ring-2 focus:ring-electric-violet/30"
        >
          <option value="">All</option>
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
      </label>
      {hasFilters && (
        <button
          onClick={() => f.reset()}
          className="ml-auto flex items-center gap-1 text-xs text-on-surface-variant hover:text-on-surface"
        >
          <X className="w-3 h-3" /> Clear
        </button>
      )}
    </div>
  );
}
